/* eslint-disable vue/valid-template-root */
<template>

<div class="myn">
    <Navbar />
        <section>
        <div class="container">
            <div class="text text-white">
                <h2>MYNInterior, Web Interior Design Service Provider</h2>

                <figure class="figure text-left">
                    <a target="_blank" href="https://www.figma.com/file/IXkGqNZvvyRHAxc6bctbuh/MYN-interior?node-id=0%3A1" style="font-size: 14px;"><i class="fas fa-link ml-2 mt-5"></i> Visit Design</a>
                    <img src="assets/MYNInterior.png" class="figure-img img-fluid mt-5" data-aos="flip-left"
                        data-aos-easing="ease-out-cubic" data-aos-duration="2000">
                    <figcaption class="figure-caption mt-3 text-center font-italic text-white">
                        Web Interior Design Service Provider
                    </figcaption>
                </figure>
            </div>
        </div>
    </section>

    <!-- Problem Statement -->
    <section>
        <div class="container text-left">
            <div class="row" data-aos="fade-right" data-aos-offset="300" data-aos-easing="ease-in-sine">
                <div class="text col-lg-6 col-md-6 col-12">
                    <h6 class="text-title">PROBLEM STATEMENT</h6>
                    <p class="text-desc">
                        Image result for important services design interior.
                        Interior designers are experts in creating more spaces, improving the space efficiency,
                        improving the functional usage of space, improving the lighting effect, improving the color
                        effects, improving the textures, patterns, scale, size.
                    </p>
                </div>
            </div>
        </div>
    </section>
    <!-- Close Problem Statement -->
    <!-- Project Goals -->
    <section>
        <div class="container text-left">
            <h6 class="text-title">PROJECT GOALS</h6>
            <div class="row" data-aos="fade-left" data-aos-offset="300" data-aos-easing="ease-in-sine">
                <div class="text col-lg-6 col-md-6 col-12">
                    <img src="assets/img/satu.png" class="mt-5" alt="">
                    <p class="text-desc">Differenciate from competitors<br>through innovation</p>
                </div>
                <div class="text col-lg-6 col-md-6 col-12">
                    <img src="assets/img/tiga.png" class="mt-5" alt="">
                    <p class="text-desc">Use technology to complement<br>the in store experience</p>
                </div>
                <div class="text col-lg-6 col-md-6 col-12">
                    <img src="assets/img/dua.png" class="mt-5" alt="">
                    <p class="text-desc">Estabilish trust and credibility<br>through excellent service</p>
                </div>
            </div>
        </div>
    </section>
    <!-- Close Project Goals -->
    <!-- Research Methods -->
    <section>
        <div class="container text-left">
            <h6 class="text-title">RESEARCH METHODS</h6>
            <div class="row" data-aos="fade-right" data-aos-offset="300" data-aos-easing="ease-in-sine">
                <div class="text col-lg-6 col-md-6 col-12">
                    <img src="assets/img/research.png" class="mt-5" width="11%" alt="">
                    <p class="text-desc">Competitive research</p>
                </div>
                <div class="text col-lg-6 col-md-6 col-12">
                    <img src="assets/img/Group 44.png" class="mt-5" width="9%%" alt="">
                    <p class="text-desc">UX Survey</p>
                </div>
                <div class="text col-lg-6 col-md-6 col-12">
                    <img src="assets/img/persona.png" class="mt-5" width="10%" alt="">
                    <p class="text-desc">Customer persona</p>
                </div>
                <div class="col col-lg-6 col-md-6 col-12">
                    <img src="assets/img/userflow.png" class="mt-5" width="13%" alt="">
                    <p class="text-desc">User flow & Journey</p>
                </div>
                <div class="col col-lg-6 col-md-6 col-12">
                    <img src="assets/img/prototype.png" class="mt-5" width="7%" alt="">
                    <p class="text-desc">Prototype testing</p>
                </div>
            </div>
        </div>
    </section>
    <!-- Close Reseacrh and methods -->
    <!-- Scope and constraints -->
    <section>
        <div class="container text-left">
            <div class="row" data-aos="fade-left" data-aos-offset="300" data-aos-easing="ease-in-sine">
                <div class="text col-lg-6 col-md-6 col-12">
                    <h6 class="text-title">SCOPE AND CONSTRAINTS</h6>
                    <p class="text-desc">Assets that I use from several platforms including for the image I took
                        from <a href="https://unsplash.com/">Unsplash</a>.
                        <br><br> I design the web design for Web Interior Design Service Provider and my partner develop it.
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <figure class="figure mt-5">
                        <img data-aos="fade-up" data-aos-duration="3000" src="assets/homepage.png" class="figure-img img-fluid mt-5">
                    </figure>
                </div>
                <div class="row">
                    <div class="col">
                        <figure class="figure mt-5">
                            <img data-aos="fade-up" data-aos-duration="3000" src="assets/style.png" class="figure-img img-fluid mt-5">
                        </figure>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Close Scope and constraints -->
    <!-- Sitemap -->
    <section>
        <div class="container text-left">
            <div class="row">
                <div class="text col-lg-6 col-md-6 col-12" data-aos="fade-right" data-aos-offset="300" data-aos-easing="ease-in-sine">
                    <h6 class="text-title">SITEMAP</h6>
                    <p class="text-desc">This sitemap is very useful to see how big the scope is and also as my guide
                        when designing the pages. When the sitemap is done, the next step wireframe.
                    </p>
                </div>
                <div class="row">
                    <div class="col">
                        <figure class="figure mt-5">
                            <img data-aos="fade-up" data-aos-duration="3000" src="assets/img/sitemap-mono.png" class="figure-img img-fluid mt-5">
                        </figure>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Close Sitemap -->
    <!-- Wireframe -->
    <!-- <section>
        <div class="container text-left">
            <div class="row">
                <div class="text col-lg-6 col-md-6 col-12" data-aos="fade-left" data-aos-offset="300" data-aos-easing="ease-in-sine">
                    <h6 class="text-title">WIREFRAME</h6>
                    <p class="text-desc">I find this wireframe process is very important so I can focus
                        on the content first. I designed the wireframe for all the pages using Figma tools.
                    </p>
                </div>
                <div class="row">
                    <div class="col">
                        <figure class="figure mt-5">
                            <img data-aos="fade-up" data-aos-duration="3000" src="assets/myn.png" class="figure-img img-fluid mt-5">
                        </figure>
                    </div>
                </div>
            </div>
        </div>
    </section> -->
    <!-- Close wireframe -->
    <!-- mockup -->
    <section>
        <div class="container text-left">
            <div class="row">
                <div class="text col-lg-6 col-md-6 col-12" data-aos="fade-right" data-aos-offset="300" data-aos-easing="ease-in-sine">
                    <h6 class="text-title">MOCKUP</h6>
                    <p class="text-desc">After finished creating the wireframe in Figma. I continue to the mockup
                        phase. Filling the images, creating some design elements, adding colors, and refining the
                        layout.
                    </p>
                </div>
                <div class="row">
                    <div class="col">
                        <figure class="figure mt-5">
                            <img data-aos="fade-up" data-aos-duration="3000" src="assets/mockup-myn.png" class="figure-img img-fluid mt-5">
                        </figure>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- close mockup -->
    <!-- result -->
    <section>
        <div class="container text-left">
            <div class="row">
                <div class="text col-lg-6 col-md-6 col-12" data-aos="fade-left" data-aos-offset="300" data-aos-easing="ease-in-sine">
                    <h6 class="text-title">RESULT</h6>
                    <p class="text-desc">With some revisions, the final design is finally done. Then the next step is
                        the development process by my partner. After about 3 weeks of development the site ready to
                        deploy and now you can see it in action.
                    </p>
                </div>
            </div>
        </div>
    </section>
    <!-- close result -->
    <!-- screen -->
    <section>
        <div class="container text-left">
            <figure class="figure mt-5">
                <img src="assets/myn.png" class="figure-img img-fluid mt-5">
            </figure>
        </div>
    </section>
    <!-- close screen -->
    <Footer />
</div>
</template>

<script>
import Footer from '../components/Footer.vue';
import Navbar from '../components/NavbarSection.vue';
export default {
    name: 'myn',
    components: { 
        Navbar,
        Footer
    },
}
</script>

<style>
    * {
        font-family: 'Rubik', sans-serif;
    }
    .text-desc {
        color: white !important;
    }
</style>